<template>
  <div v-if="uploadedFiles && uploadedFiles.length > 0 && (showProgress === 'All' || showProgress === 'Upload')" class="container mt-2 mb-2">
    <div>
      <h6 class="title">{{ $t("file-manager.upload-progress") }}</h6>
      <div v-for="(file, index) in paginatedUploadData" :key="index">
        <div class="row">
          <div class="col-md-7">
            <h6 v-b-tooltip.hover :title="$options.filters.translate(file.name)">{{ file.name | translate | summary }} - {{ file.size | formatByte }}</h6>
          </div>
          <div class="col-md-5 mt-1">
            <b-progress show-value :value="file.progress" :variant="file.status === 'error' ? 'danger' : variant" :animated="file.progress != 100" :max="100"></b-progress>
          </div>
        </div>
      </div>
      <empty v-if="uploadedFiles && uploadedFiles.length == 0" width="200px">
        <h6 class="text-center text-muted">{{ $t("file-manager.empty") }}</h6>
      </empty>
      <b-pagination
        v-if="uploadedFiles && uploadedFiles.length > uploadPagination.perPage"
        class="mt-2"
        v-model="uploadPagination.currentPage"
        :total-rows="uploadedFiles.length"
        :per-page="uploadPagination.perPage"
        limit="5"
        size="sm"
      ></b-pagination>
    </div>
    <div class="mt-4" v-if="downloadedFiles && downloadedFiles.length > 0 && (showProgress === 'All' || showProgress === 'Download')">
      <h6 class="title">{{ $t("file-manager.download-progress") }}</h6>
      <div v-for="(file, index) in paginatedDownloadData" :key="index">
        <div class="row">
          <div class="col-md-7">
            <h6 v-b-tooltip.hover :title="$options.filters.translate(file.name)">{{ file.name | translate | summary }} - {{ file.size | formatByte }}</h6>
          </div>
          <div class="col-md-5 mt-1">
            <b-progress show-value :value="file.progress" :variant="file.status === 'error' ? 'danger' : variant" :animated="file.progress != 100" :max="100"></b-progress>
          </div>
        </div>
      </div>
      <b-pagination
        v-if="downloadedFiles && downloadedFiles.length > downloadPagination.perPage"
        class="mt-2"
        v-model="downloadPagination.currentPage"
        :total-rows="downloadedFiles.length"
        :per-page="downloadPagination.perPage"
        limit="5"
        size="sm"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      uploadPagination: {
        currentPage: 1,
        perPage: 5,
      },
      downloadPagination: {
        currentPage: 1,
        perPage: 5,
      },
    };
  },

  props: {
    variant: {
      required: false,
      type: String,
      default: "success",
    },
    showProgress: {
      required: false,
      type: String,
      default: "All", //All,Upload,Download
    },
  },
  computed: {
    uploadedFiles() {
      return this.$store.getters[`fileManager/uploadedFiles`];
    },

    downloadedFiles() {
      return this.$store.getters[`fileManager/downloadedFiles`];
    },
    paginatedDownloadData() {
      const start = (this.downloadPagination.currentPage - 1) * this.downloadPagination.perPage;
      const end = start + this.downloadPagination.perPage;
      return this.downloadedFiles.slice(start, end);
    },
    paginatedUploadData() {
      const start = (this.uploadPagination.currentPage - 1) * this.uploadPagination.perPage;
      const end = start + this.uploadPagination.perPage;
      return this.uploadedFiles.slice(start, end);
    },
  },
};
</script>
